import { useState } from 'react';
import apiService from '../../axios/apiService';

export const useInvoiceList = () => {
  const [data, setData] = useState();
  const getList = async (params) => {
    // Fetch clinics list
    const list = await apiService.getAllInvoices(params);
    list && setData(list); // update data state
    return list;
  };

  return {
    data,
    getList,
  };
};
